.bannerContainer {
  background-color: var(--colors-info-main);
  color: var(--colors-text-info);
  margin-top: 24px;
  padding-left: var(--page-margin);
  padding-right: var(--page-margin);
}

.bannerContent {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  overflow-x: scroll;
  column-gap: 16px;
  scrollbar-width: none; /* Firefox */
  height: 56px;
}

.bannerContent::-webkit-scrollbar {
  display: none;
}

.fadeRight {
  mask-image: linear-gradient(to right, black 90%, transparent 100%);
}

.noFade {
  mask-image: none;
}

@media all and (--reefer-media-tablet-min) {
  .bannerContainer {
    margin-bottom: 8px;
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
  }
}
